import { PayloadAction, createReducer, combineReducers, Reducer, isAnyOf } from "@reduxjs/toolkit";
import { ChatWithShortInfo, MetaResponseChats } from "@sms/shared/chat/chat.interface";

import {
  filterChatsByUpdateDate,
  handleAddRowInList,
  mergeChatList,
  handleDeleteRowInListById
} from "../utils/helpers";

import chatActions from "./chat.actions";
import chatEntryActions from "./chat.entry-actions";

export interface ChatStore {
  chats: ChatWithShortInfo[];
  meta: MetaResponseChats | null;
  chatsCountAllNotifications: number;
  selectChatId: string | null;
}

export const chatReducer: Reducer<ChatStore> = combineReducers({
  chats: createReducer<ChatWithShortInfo[]>([], builder =>
    builder
      .addCase(
        chatActions.setChatsWithShortInfo,
        (chats: ChatWithShortInfo[], { payload }: PayloadAction<ChatWithShortInfo[]>) =>
          filterChatsByUpdateDate(mergeChatList(chats, payload))
      )
      .addCase(chatActions.resetChats, () => [])
      .addMatcher(
        isAnyOf(chatEntryActions.handleCreateChat, chatEntryActions.handleUpdateChat),
        (chats: ChatWithShortInfo[], { payload }: PayloadAction<ChatWithShortInfo>) => {
          if (payload.isArchived) {
            return handleDeleteRowInListById(chats, payload.id);
          }

          return filterChatsByUpdateDate(handleAddRowInList(chats, payload));
        }
      )
  ),
  meta: createReducer<MetaResponseChats | null>(null, builder =>
    builder.addCase(
      chatActions.setMetaChats,
      (_: MetaResponseChats | null, { payload }: PayloadAction<MetaResponseChats | null>) => payload
    )
  ),
  chatsCountAllNotifications: createReducer<number>(0, builder =>
    builder.addMatcher(
      isAnyOf(chatEntryActions.fetchCountAllNotificationsSuccess, chatEntryActions.handleCountAllNotification),
      (_: number, { payload }: PayloadAction<number>) => payload
    )
  ),
  selectChatId: createReducer<string | null>(null, builder =>
    builder.addCase(
      chatActions.switchSelectChat,
      (_: string | null, { payload }: PayloadAction<string | null>) => payload
    )
  )
});
